import { format } from 'date-fns'
import { WellLogOrSurveyFields } from '../../../../types/form-types'
import { SetValue, ValidationErrors } from '../../../hooks/use-edit-form'
import { DISPLAY_DATE_FORMAT, INTERNAL_DATE_FORMAT } from '../../../services/constants'
import { parseDate } from '../../aoraki/generic-search-common/src'
import { DateField, FormField, InputWidth, TextInput } from '@msaf/core-react'

interface WellLogOrSurveyInterface {
  fields: Partial<WellLogOrSurveyFields>
  isLoading: boolean
  setValue: SetValue<WellLogOrSurveyFields>
  validationErrors: ValidationErrors<WellLogOrSurveyFields>
}

export default function WellLogOrSurveyEdit({
  fields,
  isLoading,
  validationErrors,
  setValue,
}: WellLogOrSurveyInterface) {
  return (
    <>
      <FormField
        isSkeleton={isLoading}
        label='Survey Type'
        htmlFor='surveyType'
        validationMessages={validationErrors?.surveyType}
      >
        <TextInput
          isSkeleton={isLoading}
          type='text'
          id='surveyType'
          value={`${fields.surveyType ?? ''}`}
          setValue={(value) => setValue('surveyType', value)}
        />
      </FormField>
      <FormField isSkeleton={isLoading} label='Date' htmlFor='date' validationMessages={validationErrors?.date}>
        <DateField
          isSkeleton={isLoading}
          isDisabled={isLoading}
          fieldSize={InputWidth.large}
          dateFormat={DISPLAY_DATE_FORMAT}
          selectedDate={parseDate(fields.date)}
          setSelectedDate={(date: Date) => setValue('date', date ? format(date, INTERNAL_DATE_FORMAT) : '')}
        />
      </FormField>
      <FormField
        isSkeleton={isLoading}
        label='Data sheet'
        htmlFor='dataSheetUri'
        validationMessages={validationErrors?.dataSheetUri}
      >
        <TextInput
          isSkeleton={isLoading}
          type='text'
          id='dataSheetUri'
          value={`${fields.dataSheetUri ?? ''}`}
          setValue={(value) => setValue('dataSheetUri', value)}
        />
      </FormField>
    </>
  )
}
